var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "full-screen-modal",
      attrs: {
        id: "reason-refused-annonce",
        centered: "",
        "hide-footer": "",
        "hide-header": "",
        "ok-variant": "primary"
      }
    },
    [
      _c("div", [
        _c("div", { staticClass: "col-12 custom-col-12" }, [
          _c("div", { attrs: { id: "container-title-modal" } }, [
            _c("span", { staticClass: "page-title" }, [
              _c("i", {
                staticClass:
                  "ph-custom ph-x-circle main-red-color custom-size-icon-refused-annonce"
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "custom-col-12 mt-2" }, [
          _c("div", [
            _c("span", { staticClass: "page-title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("annonce.refused.annonce")) +
                  "\n        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("p", {
          staticClass: "mt-3",
          attrs: { id: "custom-p-modal-reason-refused" },
          domProps: {
            innerHTML: _vm._s(_vm.$t("annonce.refused.reason.content"))
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-start col-12 mt-2" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("ul", [
              _vm.reason.hasOwnProperty("identityValidated") &&
              !_vm.reason.identityValidated
                ? _c("li", [_vm._v(_vm._s(_vm.$t("identity.file")))])
                : _vm._e(),
              _vm._v(" "),
              _vm.reason.hasOwnProperty("carteGriseValidated") &&
              !_vm.reason.carteGriseValidated
                ? _c("li", [_vm._v(_vm._s(_vm.$t("carte.grise")))])
                : _vm._e(),
              _vm._v(" "),
              _vm.reason.hasOwnProperty("plainteValidated") &&
              !_vm.reason.plainteValidated
                ? _c("li", [_vm._v(_vm._s(_vm.$t("annonce.depotPlainte")))])
                : _vm._e(),
              _vm._v(" "),
              _vm.reason.hasOwnProperty("detailsValidated") &&
              !_vm.reason.detailsValidated
                ? _c("li", [_vm._v(_vm._s(_vm.$t("annonce.context.robbery")))])
                : _vm._e(),
              _vm._v(" "),
              _vm.reason.hasOwnProperty("photosValidated") &&
              !_vm.reason.photosValidated
                ? _c("li", [_vm._v(_vm._s(_vm.$t("annonce.images")))])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.reason.hasOwnProperty("commentaire") && _vm.reason.commentaire
          ? _c("p", {
              staticClass: "commentary-lamp mt-3",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("annonce.refused.commentaire.lamp", {
                    commentaire: _vm.reason.commentaire
                  })
                )
              }
            })
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83a38028", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83a38028","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceReasonRefusedModal.vue
// module id = tC5q
// module chunks = 0